/**
 * 证书类型枚举（与后端 com.ruoyi.common.enums.portal.CertificateTypeEnum 一致）
 * 0 数字备案、1 作品登记、2 软著、3 商标、4 专利
 */
export const CertificateTypeEnum = {
  ALL: { code: '-1', label: '全部知产' },
  DIGITAL_FILING: { code: '0', label: '数字备案' },
  WORK_COPYRIGHT: { code: '1', label: '作品著作权' },
  SOFTWARE_COPYRIGHT: { code: '2', label: '软件著作权' },
  TRADEMARK: { code: '3', label: '商标' },
  PATENT: { code: '4', label: '专利' }
}

/** 证书类型 code 常量（接口参数 certificateType / certType） */
export const CERTIFICATE_TYPE = {
  DIGITAL_FILING: CertificateTypeEnum.DIGITAL_FILING.code,
  WORK_COPYRIGHT: CertificateTypeEnum.WORK_COPYRIGHT.code,
  SOFTWARE_COPYRIGHT: CertificateTypeEnum.SOFTWARE_COPYRIGHT.code,
  TRADEMARK: CertificateTypeEnum.TRADEMARK.code,
  PATENT: CertificateTypeEnum.PATENT.code
}

/** 知产查询 Tab、导出文件名等展示（商标、专利带「信息」后缀） */
export const CERTIFICATE_TYPE_DISPLAY = {
  // [CERTIFICATE_TYPE.DIGITAL_FILING]: CertificateTypeEnum.DIGITAL_FILING.label,
  [CERTIFICATE_TYPE.WORK_COPYRIGHT]: CertificateTypeEnum.WORK_COPYRIGHT.label,
  [CERTIFICATE_TYPE.SOFTWARE_COPYRIGHT]: CertificateTypeEnum.SOFTWARE_COPYRIGHT.label,
  [CERTIFICATE_TYPE.TRADEMARK]: '商标信息',
  [CERTIFICATE_TYPE.PATENT]: '专利信息'
}

/** 证书类型下拉选项 */
export const CERTIFICATE_TYPE_OPTIONS = Object.values(CertificateTypeEnum).map((item) => ({
  value: item.code,
  label: item.label
}))

/**
 * 获取证书类型名称
 * @param {string|number} code
 * @returns {string}
 */
export function getCertificateTypeLabel(code) {
  const c = code == null ? '' : String(code)
  const hit = Object.values(CertificateTypeEnum).find((item) => item.code === c)
  return hit ? hit.label : ''
}
